export default {"src":"/evde-internet/_next/static/media/tick.f09e96b2.svg","height":120,"width":120};